// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-ForgotPassword__forgotPasswordForm__root","buttonContainer":"cmp-ForgotPassword__forgotPasswordForm__buttonContainer"};